export const getSelectedDeparturePostalOperators = state =>
  state.mrdPostalOperatorSelector.departure.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.mrdPostalOperatorSelector.departure.checkedMailProcessingCenters.includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getDeparturePostalOperators = state => state.mrdPostalOperatorSelector.departure.nodes;
export const getDepartureCheckedMailProcessingCenters =
    state => state.mrdPostalOperatorSelector.departure.checkedMailProcessingCenters;
export const getExpandedDeparturePostalOperators =
    state => state.mrdPostalOperatorSelector.departure.expandedPostalOperators;
export const getExpandedDeparturePostalOperatorsMrdAdmin =
    state => state.mrdPostalOperatorSelector.departure.expandedPostalOperatorsMrdAdmin;
export const getDepartureIMPCSelections =
    state => state.mrdPostalOperatorSelector.departure.selections;

export const getSelectedArrivalPostalOperators = state =>
  state.mrdPostalOperatorSelector.arrival.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.mrdPostalOperatorSelector.arrival.checkedMailProcessingCenters.includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getArrivalPostalOperators = state => state.mrdPostalOperatorSelector.arrival.nodes;
export const getArrivalCheckedMailProcessingCenters =
    state => state.mrdPostalOperatorSelector.arrival.checkedMailProcessingCenters;
export const getExpandedArrivalPostalOperators =
    state => state.mrdPostalOperatorSelector.arrival.expandedPostalOperators;
export const getArrivalIMPCSelections =
    state => state.mrdPostalOperatorSelector.arrival.selections;

export const getDirections = state =>
  state.mrdPostalOperatorSelector.directions;
export const getIsDirectionsSwitched = state =>
  state.mrdPostalOperatorSelector.directions.switched;
